
import { Component, Prop, Vue, Watch, Emit } from "vue-property-decorator";
import draggable from "vuedraggable";
import Loading from "../../../components/loading.vue";
import IceMountain from "../components/iceMountain.vue";
import { Mind, PsycGaugeConfig } from "@/lib/model/exambuilder/exam-v2";

import ExamV3Custom, {
  ExamV3Tem
} from "@/lib/model/exambuilder/exam-v3/exam-v3";
import Dimensions, { Dimension, DimensionRes } from "@/lib/dimension/dimension";
import Auth from "@/lib/common/auth";
import {
  BasicQuality,
  GameTest,
  IseEnglish,
  IseChinese
} from "@/lib/model/exambuilder/exam-v3/exam-v3-sub";

import { QuestionV2 } from "@/lib/model/exambuilder/question-v2";

import { TagIcon } from "@/lib/enum/tool";

// 因为基础素质维度信息与其他信息存在差异，所以以维度信息为继承类
export class ToolCheckItem extends Dimension {
  toLock = false;
  inspect = "";
  dimensionName = "";
  dimensionDesc = "";
  icon = "";
  childIcon = "";
  constructor(
    iconList = ["", ""],
    inspect = "",
    dimensionName = "",
    dimensionDesc = "",
    toLock = false
  ) {
    super();
    this.icon = iconList[0];
    this.childIcon = iconList[1];
    this.toLock = toLock;
    this.inspect = inspect;
    this.dimensionName = dimensionName;
    this.dimensionDesc = dimensionDesc;
  }
  // 选中取消
  select = () => {
    if (this.toLock) return;
    this.checked = !this.checked;
  };
}

export class BasicQualityDimension {
  dimensionParentGroupId = 0; // 维度父级分类id
  dimensionParentGroupName = ""; // 维度父级分类名称
  dimensionParentGroupDesc = ""; // 维度父级分类描述
  children: Dimension[] = []; //基础素质维度列表
}
@Component({
  components: { draggable, Loading, IceMountain }
})
export default class SetQuestion extends Vue {
  @Prop({ type: String, default: "exam" })
  mode!: "exam" | "template";
  @Prop({ type: String, default: "" })
  tacToken!: string;
  @Prop({ type: Object, default: null })
  exam!: ExamV3Custom | ExamV3Tem;
  @Prop({ type: String, default: "" }) fromTemplateStoreId!: string; //模板库带入id
  @Prop({ type: Boolean, default: false }) isEdit!: boolean; //是否编辑页面
  @Prop() isFirstEnter!: boolean; // 是否第一次进入该页面
  @Prop({}) companyPower!: any; //公司权限
  @Prop() cacheDimensionList!: Dimension[];
  @Prop({ default: () => [new PsycGaugeConfig()] })
  mindList!: PsycGaugeConfig[]; // 心理测评list
  tagIcon = TagIcon;
  showRemoveVisible = false;
  removeDimensionInfo = {
    tool: new ToolCheckItem(),
    questionList: [] as QuestionV2[]
  };
  // --------
  toolList = [
    {
      label: "体质仪表",
      icon: TagIcon[0],
      checkList: [
        new ToolCheckItem(
          [TagIcon[0], "&#xe6f2;"],
          "考查方式：视频检测",
          "手部综合检测",
          "通过对候选人的手部进行 AI 识别，检测候选人是否存在残疾/疤痕/纹身的情况"
        ),
        new ToolCheckItem(
          [TagIcon[0], "&#xe6f9;"],
          "考查方式：选择题",
          "辨色检测",
          "通过对图片上的内容进行识别判断，来检测候选人是否存在色盲/色弱的情况"
        )
      ],
      desc:
        "泛指体力体质、外貌特征、形体与生理检测，以评估是否符合岗位所需的重要身体和生理要求。目前的检查涵盖外貌外观、色盲检测和面部/肢体的综合检测。"
    },
    {
      label: "工作匹配",
      icon: TagIcon[1],
      checkList: [
        new ToolCheckItem(
          [TagIcon[1], "&#xe6f5;"],
          "考查方式：背调查询",
          "手机号实名认证",
          "通过采集候选人姓名、证件信息、查验手机号的号主是否为候选人本人"
        ),
        new ToolCheckItem(
          [TagIcon[1], "&#xe6fa;"],
          "考查方式：背调查询",
          "金融风险记录查询",
          "在候选人确定授权后，查询身份证及手机号维度用户的金融风险状况，包括逾期、欺诈风险、关联风险等"
        ),
        new ToolCheckItem(
          [TagIcon[1], "&#xe6ed;"],
          "考查方式：背调查询",
          "负面社会安全记录查询",
          "在候选人确定授权后，通过姓名、身份证号查询是否存在公安不良记录，包括前科、涉毒等"
        )
      ],
      desc:
        "通过简历等信息采集，测量候选人的过往学习和从业经历、职业资格或取得的成就、薪酬、职业发展规划、社会安全及金融风险等与工作岗位要求的匹配程度。"
    },
    {
      label: "知识技能",
      icon: TagIcon[2],
      checkList: [
        new ToolCheckItem(
          [TagIcon[2], "&#xe6f3;"],
          "考查方式：视频面试",
          "英语口语测试",
          "根据候选人的表达流利度、发音准确度、词汇丰富度和语法准确度评估其英文口语水平"
        ),
        new ToolCheckItem(
          [TagIcon[2], "&#xe6fb;"],
          "考查方式：视频面试",
          "普通话口语测试",
          "根据候选人回答内容的发音、语调等来评估其普通话口语水平"
        ),
        new ToolCheckItem(
          [TagIcon[2], "&#xe6f8;"],
          "考查方式：小游戏",
          "风险偏好小游戏",
          "是一个形式为打气球的游戏化测评，时间为3分钟。通过候选人在游戏内的操作，科学分析候选人的风险收益偏好及认知能力。通过报告解读帮助HR进一步了解候选人"
        )
      ],
      desc:
        "通过专业、客观的测评，深入挖掘候选人对岗位所要求的知识与技能掌握程度，为企业选拔优秀人才提供有力支持。"
    },
    {
      label: "基础素质",
      icon: TagIcon[3],
      checkList: [new ToolCheckItem()],
      desc:
        "基础素质泛指胜任某一岗位工作或担任某一特定的任务角色所需要具备的一些特质和能力的总和，即针对特定职位表现优异的那些要求结合起来的胜任特征结构。如：学习能力、抗压力等通用能力；数据分析、谈判能力等专业能力，以及认知能力等基础素质。"
    },
    {
      label: "心理动机",
      icon: TagIcon[4],
      checkList: [],
      desc:
        "结合公司核心价值观和岗位特性，运用专业的心理测评工作，帮助企业选拔人才、安置岗位，以及对一个人进行诊断、评价、辅助咨询。如职业价值观、性格测评、人格测评、心理风险等。"
    }
  ];
  toolTarget = 3; //默认 基础素质

  basicQualityList: BasicQualityDimension[] = []; //基础素质维度列表
  backupBasicQualityList: BasicQualityDimension[] = []; //备份基础素质维度列表

  dimensionList: ToolCheckItem[] = []; // 选中的维度
  searchText = ""; //搜索基础素质名称

  dimensionLoading = true;

  sureRemove(item: ToolCheckItem) {
    console.log("fdsf:", item, item.icon === TagIcon[2]);
    // 知识技能
    this.knowledgeAndSkills(false);
    if (item.icon === TagIcon[3]) {
      this.basicSelect(item);
    }
    if (item.icon === TagIcon[2]) {
      item.select();
      // 知识技能
      this.knowledgeAndSkills(false);
    }

    this.showRemoveVisible = false;
  }

  // 处理搜索框输入样式
  @Watch("searchText")
  onInputValue() {
    this.$nextTick(() => {
      const input = document.querySelector("#search") as HTMLElement;
      const emptyText = document.querySelector(".emptyText") as HTMLElement;
      if (input && emptyText) {
        const paddingRight = this.searchText
          ? input.offsetWidth - emptyText.offsetWidth
          : 64;
        input.style.cssText = `padding-right:${
          paddingRight > 64 ? paddingRight - 1 : 64
        }px !important;height: 36px !important;line-height: 36px !important;font-family: none;
				padding: 0 12px;font-size: 14px !important;font-weight: 400 !important;color: #111 !important;
				caret-color: #525fff;border: 1px solid #cbd6e2;border-radius: 6px !important;`;
      }
    });
  }

  // 所有工具选中项
  get allToolTargetList() {
    const allToolList = this.toolList.reduce((pre: any[], current: any) => {
      const targetList = current.checkList.filter(
        (tool: ToolCheckItem) => tool.checked
      );
      pre.push(...targetList);
      return pre;
    }, []);
    return allToolList;
  }

  // 设置工具栏心理动机
  mindToolSet(mindList: PsycGaugeConfig[]) {
    // 顺序
    this.toolList[4].checkList.push(
      new ToolCheckItem(
        [TagIcon[4], "&#xe6f4;"],
        "考查方式：选择题",
        mindList[1].psycGaugeName,
        mindList[1].descriptionSmall
      )
    );
    this.toolList[4].checkList.push(
      new ToolCheckItem(
        [TagIcon[4], "&#xe6ec;"],
        "考查方式：选择题",
        mindList[0].psycGaugeName,
        mindList[0].descriptionSmall
      )
    );
    this.toolList[4].checkList.push(
      new ToolCheckItem(
        [TagIcon[4], "&#xe6eb;"],
        "考查方式：选择题",
        mindList[2].psycGaugeName,
        mindList[2].descriptionSmall
      )
    );
    this.toolList[4].checkList.push(
      new ToolCheckItem(
        [TagIcon[4], "&#xe6f1;"],
        "考查方式：选择题",
        mindList[3].psycGaugeName,
        mindList[3].descriptionSmall
      )
    );
    // 心理动机
    this.psychologicalMotivation();
  }

  // 搜索清空
  clearSearch() {
    this.searchText = "";
    this.basicQualityList = [...this.backupBasicQualityList];
  }

  changeSearch() {
    if (this.searchText) {
      this.basicQualityList = this.backupBasicQualityList.reduce(
        (pre: BasicQualityDimension[], current: BasicQualityDimension) => {
          const list = current.children.filter(d =>
            d.dimensionName.includes(this.searchText)
          ) as Dimension[];
          const basicDimen = new BasicQualityDimension();
          if (list.length) {
            basicDimen.children = list;
            basicDimen.dimensionParentGroupId = current.dimensionParentGroupId;
            basicDimen.dimensionParentGroupName =
              current.dimensionParentGroupName;
            basicDimen.dimensionParentGroupDesc =
              current.dimensionParentGroupDesc;
            pre.push(basicDimen);
          }
          return pre;
        },
        [] as BasicQualityDimension[]
      );
    } else {
      this.clearSearch();
    }
  }

  // 当前为基础素质
  get toolBasic() {
    return this.toolTarget === 3;
  }

  // 当前工具
  get currenTtool() {
    const tool = this.toolList[this.toolTarget];
    return tool;
  }

  selectTarget(item: ToolCheckItem, del = false) {
    // 基础素质操作
    if (item.icon === TagIcon[3]) {
      const delTarget = this.exam.processInformation.basicQualityList.find(
        basic => basic.dimensionKey === item.dimensionKey
      );
      if (delTarget) {
        if (delTarget.questionIdList.find(qId => qId !== 0)) {
          // 提示
          this.removeDimensionInfo.tool = item;
          this.removeDimensionInfo.questionList = delTarget.questionList;
          this.showRemoveVisible = true;
          return;
        } else {
          this.basicSelect(item);
          return;
        }
      } else {
        this.basicSelect(item);
        return;
      }
    }

    // 心理动机操作
    if (item.icon === TagIcon[4]) {
      const mind = { ...item };
      // 心理动机单选
      this.toolList[4].checkList.forEach(mind => (mind.checked = false));
      if (!del && !mind.checked) item.select();
      // 心理动机
      this.psychologicalMotivation(false);
      return;
    }

    if (item.icon === TagIcon[2] && item.checked) {
      if (item.dimensionName === "英语口语测试") {
        const target = this.exam.processInformation.knowledgeAndSkills.iseEnglish.questionIdList.find(
          qId => qId !== 0
        );
        if (target) {
          // 提示
          this.removeDimensionInfo.tool = item;
          this.removeDimensionInfo.questionList = this.exam.processInformation.knowledgeAndSkills.iseEnglish.questionList;
          this.showRemoveVisible = true;
          return;
        }
      }
      if (item.dimensionName === "普通话口语测试") {
        const target = this.exam.processInformation.knowledgeAndSkills.iseChinese.questionIdList.find(
          qId => qId !== 0
        );
        if (target) {
          // 提示
          this.removeDimensionInfo.tool = item;
          this.removeDimensionInfo.questionList = this.exam.processInformation.knowledgeAndSkills.iseChinese.questionList;
          this.showRemoveVisible = true;
          return;
        }
      }
    }
    // 其他
    item.select();
    // 体质仪表
    this.physicalInstrument(false);
    // 工作匹配
    this.jobMatching(false);
    // 知识技能
    this.knowledgeAndSkills(false);
  }

  // 基础素质项的操作
  basicSelect(item: ToolCheckItem) {
    const list = this.toolList[3].checkList;
    const dimensionList = list.filter(d => d.checked);
    if (dimensionList.length >= 12 && !item.checked) {
      return this.$message.warning("基础素质最多选择12项");
    }
    item.select();
    this.basicQuality(false);
  }

  // 获取维度列表
  async getDimensionList() {
    const param: any = {
      companyId: this.mode === "exam" ? Number(Auth.companyId) : 0,
      onlyNormalDimension: 1,
      isExamEnv: Number(this.isEdit),
      withExamId: this.mode === "exam" ? (this.exam as ExamV3Custom).examId : 0
    };

    if (this.mode === "template") {
      Dimensions.tacGet(param, this.tacToken).then((res: DimensionRes) => {
        this.addBasicDimendion(res.list);
      });
    } else {
      Dimensions.get(param).then((res: DimensionRes) => {
        this.addBasicDimendion(res.list);
      });
    }
  }

  // 工具栏添加基础素质
  addBasicDimendion(list: Dimension[]) {
    this.toolList[3].checkList = list.map(item => {
      const basicDimen = new ToolCheckItem().assign(item);
      basicDimen.icon = TagIcon[3];
      return basicDimen;
    });
    // 基础素质
    this.basicQuality();
    // 传递父级备份
    this.$emit("update:cacheDimensionList", list);
    this.manageDimensionList(this.toolList[3].checkList);
  }

  // 维度
  manageDimensionList(list: ToolCheckItem[]) {
    const r = list.reduce(
      (pre: BasicQualityDimension[], current: Dimension) => {
        if (this.mode === "template" && current.dimensionKey === "自定义客观题")
          return pre;

        const target = pre.find(
          item => item.dimensionParentGroupId === current.dimensionParentGroupId
        ) as BasicQualityDimension;
        if (target) {
          target.children.push(current);
        } else {
          const basicQuality = new BasicQualityDimension();
          basicQuality.dimensionParentGroupName =
            current.dimensionParentGroupName;
          basicQuality.dimensionParentGroupId = current.dimensionParentGroupId;
          basicQuality.dimensionParentGroupDesc =
            current.dimensionParentGroupDesc;
          basicQuality.children.push(current);
          pre.push(basicQuality);
        }
        return pre;
      },
      [] as BasicQualityDimension[]
    );
    this.basicQualityList = r;
    // 存备份
    this.backupBasicQualityList = r;
  }

  async mounted() {
    this.status();
    if (!this.cacheDimensionList.length) {
      await this.getDimensionList();
    } else {
      this.addBasicDimendion(this.cacheDimensionList);
    }
    //心理
    this.mindToolSet(this.mindList);
    // 体质仪表
    this.physicalInstrument();
    // 工作匹配
    this.jobMatching();
    // 知识技能
    this.knowledgeAndSkills();
    this.$nextTick(() => {
      this.dimensionLoading = false;
      this.status();
    });
    this.checkToolPower();
  }

  //公司是否有权限
  powerCheck(key: string) {
    return this.companyPower?.[key] === 1;
  }

  @Watch("companyPower", { immediate: true, deep: true })
  onAuthority() {
    // 体质仪表-手部检查（创建模版时，正式环境全上锁，测试环境全打开）
    if (this.mode === "template") {
      if (process.env.NODE_ENV == "production") {
        this.toolList[0].checkList[0].toLock = true;
        return;
      } else if (process.env.NODE_ENV === "test") return;
    }
    this.checkToolPower();
  }
  //检查配置项权限
  checkToolPower() {
    const a = this.toolList;
    debugger;
    this.toolList.forEach((item, index) => {
      if (index === 0) {
        item.checkList.forEach((tool, i) => {
          if (i === 0) {
            tool.toLock = !this.powerCheck("enableFingerTest"); //手部综合检测
          }
          if (i === 1) {
            tool.toLock = false; // !this.powerCheck("enableColorTest"); //辨色检测
          }
        });
      }
      if (index === 1) {
        item.checkList.forEach((tool, i) => {
          if (i === 0) {
            tool.toLock = !this.powerCheck("enablePeoplePhoneCheck"); //手机号实名认证
          }
          if (i === 1) {
            tool.toLock = !this.powerCheck("enableMoneyCheck"); //金融风险记录查询
          }
          if (i === 2) {
            tool.toLock = !this.powerCheck("enableBadHistroy"); //负面社会安全记录查询
          }
        });
      }
      if (index === 2) {
        item.checkList.forEach((tool, i) => {
          if (i === 0) {
            tool.toLock = false; //!this.powerCheck("enableIseEnglish");//英语口语测试?
          }
          if (i === 1) {
            tool.toLock = false; //!this.powerCheck("enableIseChinese");//普通话口语测试?
          }
          if (i === 2) {
            tool.toLock = !this.powerCheck("enableGameTest"); //风险偏好小游戏
          }
        });
      }

      if (index === 4) {
        item.checkList.forEach((tool, i) => {
          if (i === 0) {
            tool.toLock = !this.powerCheck("enablePsycTest");
          }
          if (i === 1) {
            tool.toLock = !this.powerCheck("enablePsycTest");
          }
          if (i === 2) {
            tool.toLock = !this.powerCheck("enablePsycTest");
          }
          if (i === 3) {
            tool.toLock = !this.powerCheck("enablePsycTest");
          }
        });
      }
    });
  }

  // 体质仪表 (参数默认为导入)
  physicalInstrument(importOrExport = true) {
    const physicalInstrumentList = this.toolList[0].checkList;
    if (importOrExport) {
      physicalInstrumentList[0].checked =
        this.exam.processInformation.physicalInstrument.fingerTest.use === 1;
      physicalInstrumentList[1].checked =
        this.exam.processInformation.physicalInstrument.colorTest.use === 1;
    } else {
      physicalInstrumentList.forEach((item, index) => {
        const key = ["fingerTest", "colorTest"][index];
        const info = this.exam.processInformation.physicalInstrument[key];
        if (index === 0) {
          // 公司没权限，则不选中
          info.use = Number(item.toLock ? 0 : item.checked);
        } else {
          info.use = Number(item.checked);
        }
        // 取消选中时重置数据
        if (info.use !== 1) {
          this.exam.processInformation.physicalInstrument[key] = info.reset();
        }
      });
      this.change();
    }
  }
  // 工作匹配 (参数默认为导入)
  jobMatching(importOrExport = true) {
    if (importOrExport) {
      this.toolList[1].checkList.forEach((item, index) => {
        item.checked =
          this.exam.processInformation.jobMatching[
            ["identityInfo", "socialInfo", "financialRisk"][index]
          ] === 1;
      });
    } else {
      this.toolList[1].checkList.forEach((item, index) => {
        this.exam.processInformation.jobMatching[
          ["identityInfo", "socialInfo", "financialRisk"][index]
        ] = Number(item.checked);
      });
      this.change();
    }
  }
  // 知识技能 (参数默认为导入)
  knowledgeAndSkills(importOrExport = true) {
    const knowledgeAndSkillList = this.toolList[2].checkList;
    if (importOrExport) {
      knowledgeAndSkillList[0].checked =
        this.exam.processInformation.knowledgeAndSkills.iseEnglish.use === 1;
      knowledgeAndSkillList[1].checked =
        this.exam.processInformation.knowledgeAndSkills.iseChinese.use === 1;
      if (this.exam.processInformation.knowledgeAndSkills.gameTestList[0]) {
        knowledgeAndSkillList[2].checked =
          this.exam.processInformation.knowledgeAndSkills.gameTestList[0]
            .gameTestType === 1;
      }
      this.change();
    } else {
      if (!knowledgeAndSkillList[0].checked) {
        const english = new IseEnglish();
        english.use = 0;
        this.exam.processInformation.knowledgeAndSkills.iseEnglish = english;
      } else {
        this.exam.processInformation.knowledgeAndSkills.iseEnglish.use = 1;
      }
      if (!knowledgeAndSkillList[1].checked) {
        const chinese = new IseChinese();
        chinese.use = 0;
        this.exam.processInformation.knowledgeAndSkills.iseChinese = chinese;
      } else {
        this.exam.processInformation.knowledgeAndSkills.iseChinese.use = 1;
      }

      if (this.exam.processInformation.knowledgeAndSkills.gameTestList[0]) {
        this.exam.processInformation.knowledgeAndSkills.gameTestList[0].gameTestType = knowledgeAndSkillList[2]
          .checked
          ? 1
          : 0;
      } else {
        const game = new GameTest();
        game.gameTestType = knowledgeAndSkillList[2].checked ? 1 : 0;
        this.exam.processInformation.knowledgeAndSkills.gameTestList.push(game);
      }
      this.change();
    }
  }
  // 基础素质 (参数默认为导入)
  basicQuality(importOrExport = true) {
    const dimensionList = this.toolList[3].checkList;
    if (importOrExport) {
      this.exam.processInformation.basicQualityList.forEach(basic => {
        const dimension = dimensionList.find(
          d => d.dimensionKey === basic.dimensionKey
        );
        if (dimension) {
          dimension.checked = true;
        }
      });
    } else {
      const list = dimensionList.filter(d => d.checked);
      this.exam.processInformation.basicQualityList = list.map(d => {
        const value = this.exam.processInformation.basicQualityList.find(
          item => item.dimensionKey === d.dimensionKey
        );
        return value || new BasicQuality().assign(d);
      });
      this.change();
    }
  }
  // 心理动机 (参数默认为导入)
  psychologicalMotivation(importOrExport = true) {
    if (importOrExport) {
      this.toolList[4].checkList.forEach((item, index) => {
        item.checked =
          this.exam.processInformation.psychologicalMotivation[
            ["psyc3", "psyc1", "psyc4", "psyc5"][index]
          ].use === 1;
      });
    } else {
      this.toolList[4].checkList.forEach((item, index) => {
        const key = ["psyc3", "psyc1", "psyc4", "psyc5"][index];
        const info = this.exam.processInformation.psychologicalMotivation[key];
        info.use = Number(item.checked);
        // 取消选中时重置数据
        if (info.use !== 1) {
          this.exam.processInformation.psychologicalMotivation[
            key
          ] = info.reset();
        }
      });
      this.change();
    }
  }

  //离开前数据校验
  checkData() {
    const dimensionList = this.toolList[3].checkList.filter(d => d.checked);
    if (!dimensionList.length) {
      this.$message.warning("请在【基础素质】中至少选择一项考查内容");
      this.toolTarget = 3;
      return false;
    }
    return true;
  }

  @Emit()
  change() {
    return;
  }
  @Emit()
  status() {
    return !this.dimensionLoading;
  }
}
